import EntitiesList from 'components/entities/EntitiesList';
import { connect } from 'react-redux'
import { Card } from "semantic-ui-react";
import { createEntityWithDefaults } from "../../actions/entities";
import { refreshEntities } from "../../actions/entities";
import { destroyEntity } from "../../actions/entities";
import { getTemplates } from "../../selectors/templates";
import TemplateForm from "./TemplateForm";
import TemplateListItem from "./TemplateListItem";

const mapStateToProps = (state, ownProps) => {
  return {
    entities: getTemplates(ownProps.kind)(state),
    entityName: 'template',
    item: TemplateListItem,
    form: TemplateForm,
    listComponent: Card.Group,
    loading: state.meta?.location?.loading,
    error: state.meta?.location?.error,
    title: I18n.t(`components.templates_list.title.${ownProps.kind}`)
  };
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    destroyEntity: (template) => {
      dispatch(destroyEntity('template', template.id)).then(
        () => {
          dispatch(refreshEntities('templates'))}
      )

    },
    createEntityWithDefaults: () => {
      return dispatch(createEntityWithDefaults('template', {kind: ownProps.kind} ))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EntitiesList)
